import React from 'react';

export default function MemberCard({imageName}) {
  const CardImage = require(`../svg/whatIsThis/${imageName}`).default;
  return <CardImage/>
}
